import { ApolloCache } from '@apollo/client';
import { GetObjectQuery, GetObjectDocument } from '../queries/generated/GetObject';

export const updateObjectCache = (cache: ApolloCache<any>, objectId: string, isActive: boolean) => {
  const existingObject = cache.readQuery<GetObjectQuery>({
    query: GetObjectDocument,
    variables: {
      input: {
        objectId,
      },
    },
  });

  if (existingObject?.getObject) {
    cache.writeQuery({
      query: GetObjectDocument,
      variables: {
        input: {
          objectId,
        },
      },
      data: {
        getObject: {
          ...existingObject.getObject,
          isActive,
        },
      },
    });
  }
};
